import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'palantir-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class PalantirSkeletonComponent {}
